// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Xn-z","badgeLink":"Yn-z","category":"Zn-z"};